/* @index('./*.ts', f => `export * from '${f.path}';`) */
export * from './translate-array.module';
export * from './translate-array.pipe';
export * from './translate-array.service';
/* @endindex */
